export default "__VITE_ASSET__9JZPdDWQ__"